import { audioManager } from "../lib/audioManager";

interface Props {
  canPlay: boolean;
  canReplay: boolean;
  listenStarted: boolean;
  audioLoading?: boolean;
  audioFailed?: boolean;
  onPlay: () => void;
  roundEndsAt: number | null;
  roundDurationSeconds: number;
}

export function AudioController({
  canPlay,
  canReplay,
  listenStarted,
  audioLoading = false,
  audioFailed = false,
  onPlay,
  roundEndsAt,
  roundDurationSeconds,
}: Props) {
  const waitingForPlayback = listenStarted && !roundEndsAt;
  const remaining =
    listenStarted && roundEndsAt
      ? Math.max(0, Math.ceil((roundEndsAt - Date.now()) / 1000))
      : roundDurationSeconds;

  const showPlayButton = canPlay && ((!listenStarted || canReplay || audioFailed) && !audioLoading);

  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-3">
      {showPlayButton && (
        <button
          type="button"
          className="cw-btn cw-btn-primary cw-btn-game"
          onClick={() => {
            void audioManager.unlockWithUserGesture().then(onPlay);
          }}
        >
          {audioFailed ? (
            "Réessayer l'extrait"
          ) : listenStarted ? (
            "Réécouter"
          ) : (
            <>
              <span className="sm:hidden">Lancer</span>
              <span className="hidden sm:inline">Lancer l&apos;extrait</span>
            </>
          )}
        </button>
      )}
      {audioLoading || waitingForPlayback ? (
        <span className="text-xs sm:text-sm text-yellow-300/90 tabular-nums" aria-live="polite">
          Chargement de l&apos;extrait…
        </span>
      ) : audioFailed ? (
        <span className="text-xs sm:text-sm text-red-300/90" aria-live="polite">
          Échec du chargement
        </span>
      ) : (
        <span
          className={`tabular-nums min-w-[3.25rem] sm:min-w-[4.5rem] text-center text-xs sm:text-base ${
            listenStarted ? "text-violet-300" : "text-violet-400/70"
          }`}
          aria-live="polite"
        >
          ⏱ {remaining}s
        </span>
      )}
    </div>
  );
}
